
// Fastclick to fix iOS tap delay
require('fastclick')(document.body)

// Polyfills
require('svg4everybody/dist/svg4everybody')()
//require('picturefill')


// Cutting the mustard
if(
	//false &&
	'querySelector' in document &&
	'localStorage' in window &&
	'addEventListener' in window &&
	'dataset' in document.body
) {
	document.body.classList.remove('noJs')

	// Touch-screen specific code
	let touch = require('./script/touch')
	touch()

	require('./script/cart')
	require('./script/nav')()
	require('./script/checkout')

	// Ajax-ify pages
	const Ajax = require('./script/ajax')
	const socialAuth = [
		require('./script/facebook-sign-in'),
		require('./script/google-sign-in')
	]
	const ajax = new Ajax({
		siteModules: [
			require('./script/add-to-cart-ajax'),
			require('./script/format-card')
		],
		pageModules: {
			'/': require('./script/product'),
			//'/videos': require('./script/videos'),
			//'/category/sights': require('./script/sorting'),
			//'/faq': require('./script/faq'),
			//'/login': socialAuth,
			//'/register': socialAuth
		},
		// Don't hijack these selectors
		excludeLinks: [
			//'.subImg .thumbnails a'
		],
		// Don't hijack any links on these pages
		excludeFrom: [
			'/register',
			'/login',
			'/signout',
			'/cart',
			'/checkout',
			'/checkout/**/*',
			'/account',
			'/account/**/*',
			//'/help'
		],
		disable: true
	})


}
else{
	document.body.className += ' mustard'
}
